import React, { useEffect, useState, useCallback } from "react";
import api from "../api/axios";
import toast from "react-hot-toast";

export default function Fund() {
  // Crypto funding mode is disabled for now; retain its original state for later.
  const [paymentMethod, setPaymentMethod] = useState("squad");
  const [amount, setAmount] = useState("");
  // const [coin, setCoin] = useState("USDT");
  // const [walletAddress, setWalletAddress] = useState("");
  // const [network, setNetwork] = useState("TRC20");
  const [walletBalance, setWalletBalance] = useState(0);
  // const [cryptoBalances, setCryptoBalances] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchBalances = useCallback(async () => {
    try {
      const walletRes = await api.get("/wallet");
      // const [walletRes, cryptoRes] = await Promise.all([api.get("/wallet"), api.get("/crypto/balances")]);

      setWalletBalance(walletRes.data.balance || 0);
      // setCryptoBalances(cryptoRes.data || {});
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchBalances();
  }, [fetchBalances]);

  const handleFund = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (paymentMethod === "squad") {
        const { data } = await api.post("/payments/squad/init", { amount });
        if (!data.checkoutUrl) throw new Error("Squad did not return a checkout link.");
        window.location.assign(data.checkoutUrl);
        return;
      }

      if (paymentMethod === "flutterwave") {
        const { data } = await api.post("/payments/flutterwave/init", { amount, currency: "NGN" });
        const checkoutUrl =
          data?.init?.data?.authorization_url ||
          data?.init?.data?.link ||
          data?.init?.data?.meta?.authorization_url ||
          data?.init?.link;

        if (!checkoutUrl) throw new Error("Flutterwave did not return a checkout link.");
        window.location.assign(checkoutUrl);
      } /* else {
        const res = await api.post("/crypto/deposit", {
          coin,
          walletAddress,
          network,
          amount,
        });
        toast.success(res.data.message || "Crypto deposit initiated");
      } */

      setAmount("");
      // setWalletAddress("");
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-2xl space-y-6 text-white">
      <section className="rounded-[2rem] border border-white/10 bg-slate-900/75 p-6 backdrop-blur-xl">
        <h1 className="text-2xl font-bold">Fund Wallet</h1>
        <p className="mt-1 text-sm text-slate-400">Top up your NGN balance.</p>
      </section>

      <section className="rounded-[2rem] border border-white/10 bg-slate-900/75 p-6 backdrop-blur-xl">
        <p className="text-xs uppercase tracking-wider text-slate-400">Wallet Balance</p>
        <p className="mt-1 text-3xl font-bold text-cyan-300">₦{Number(walletBalance).toLocaleString()}</p>
        {/*
        <hr className="my-4 border-white/10" />
        <p className="mb-2 text-sm font-semibold text-slate-300">Crypto Balances</p>
        <ul className="space-y-1 text-sm text-slate-300">
          {Object.entries(cryptoBalances).length ? (
            Object.entries(cryptoBalances).map(([coin, balance]) => (
              <li key={coin}>
                {coin}: <span className="font-semibold">{balance}</span>
              </li>
            ))
          ) : (
            <li>No crypto balance</li>
          )}
        </ul>
        */}
      </section>

      <section className="rounded-[2rem] border border-white/10 bg-slate-900/75 p-6 backdrop-blur-xl">
      {/*
      <div className="mb-6 flex flex-col gap-3 md:flex-row">
        <button
          className={`px-4 py-2 rounded-lg font-medium ${
            type === "bank"
              ? "bg-cyan-300 text-slate-950"
              : "bg-white/5 border border-white/10 text-slate-300"
          }`}
          onClick={() => setType("bank")}
        >
          Bank Deposit
        </button>
        <button
          className={`px-4 py-2 rounded-lg font-medium ${
            type === "crypto"
              ? "bg-cyan-300 text-slate-950"
              : "bg-white/5 border border-white/10 text-slate-300"
          }`}
          onClick={() => setType("crypto")}
        >
          Crypto Deposit
        </button>
      </div>
      */}
      <div className="mb-6 rounded-[1.5rem] border border-white/10 bg-slate-900/75 p-4">
        <p className="text-sm uppercase tracking-[0.2em] text-slate-400">Payment Provider</p>
        <div className="mt-3 grid grid-cols-2 gap-3" role="group" aria-label="Choose payment provider">
          {[{ id: "squad", label: "Squad" }, { id: "flutterwave", label: "Flutterwave" }].map((provider) => (
            <button
              key={provider.id}
              type="button"
              aria-pressed={paymentMethod === provider.id}
              onClick={() => setPaymentMethod(provider.id)}
              className={`rounded-xl border px-4 py-3 text-sm font-semibold transition ${
                paymentMethod === provider.id
                  ? "border-cyan-300 bg-cyan-300 text-slate-950"
                  : "border-white/10 bg-white/5 text-slate-300 hover:bg-white/10"
              }`}
            >
              {provider.label}
            </button>
          ))}
        </div>
      </div>

      <form onSubmit={handleFund} className="space-y-4">
        <div>
          <label className="mb-1 block text-sm text-slate-300">Amount</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
            className="w-full rounded-xl border border-white/15 bg-white/5 p-2.5 text-white outline-none focus:ring-2 focus:ring-cyan-300/35"
          />
        </div>

        {/* {type === "crypto" && (
          <>
            <div>
              <label className="mb-1 block text-sm text-slate-300">Coin</label>
              <select
                value={coin}
                onChange={(e) => setCoin(e.target.value)}
                className="w-full rounded-xl border border-white/15 bg-white/5 p-2.5 text-white outline-none focus:ring-2 focus:ring-cyan-300/35"
              >
                <option value="USDT">USDT</option>
                <option value="BTC">BTC</option>
                <option value="ETH">ETH</option>
              </select>
            </div>

            <div>
              <label className="mb-1 block text-sm text-slate-300">Wallet Address</label>
              <input
                type="text"
                value={walletAddress}
                onChange={(e) => setWalletAddress(e.target.value)}
                required
                placeholder="Enter crypto wallet address"
                className="w-full rounded-xl border border-white/15 bg-white/5 p-2.5 text-white placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-cyan-300/35"
              />
            </div>

            <div>
              <label className="mb-1 block text-sm text-slate-300">Network</label>
              <select
                value={network}
                onChange={(e) => setNetwork(e.target.value)}
                className="w-full rounded-xl border border-white/15 bg-white/5 p-2.5 text-white outline-none focus:ring-2 focus:ring-cyan-300/35"
              >
                <option value="TRC20">TRC20</option>
                <option value="ERC20">ERC20</option>
                <option value="BEP20">BEP20</option>
              </select>
            </div>
          </>
        )} */}

        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-xl bg-accent py-3 font-semibold text-slate-950 transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {loading ? "Connecting..." : `Continue with ${paymentMethod === "squad" ? "Squad" : "Flutterwave"}`}
        </button>
      </form>
      </section>
    </div>
  );
}
